import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {ref, inject, onMounted} from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { Auth, DataStore } from 'aws-amplify';
import PageLoading from '../components/PageLoading.vue'
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib-esm/types/Auth';
import { useCookies } from 'vue3-cookies';
import liff from '@line/liff'
import oauthProd from '../aws-oauth-config.prod'
import oauthStg from '../aws-oauth-config.stg'


export default /*#__PURE__*/_defineComponent({
  emits: ['stopLoading'],
  setup(__props, { emit }) {

Auth.configure({ oauth: process.env.ENV == 'prod' ? oauthProd : oauthStg })



const {cookies} = useCookies();

const router = useRouter();
const route = useRoute();

const loading = ref(false);

onMounted(async() => {
  try {    
    const query: any = route.query;

    console.log(query);

    if (query['liff.state']) {
      console.log(query['liff.state'])
      let buf: string = query['liff.state'];
      console.log(buf);

      const params = buf.replace('?', '').split('&');
      const key = params[0].split('=')[0];
      const val = params[0].split('=')[1];

      if (key == 'token') {
        cookies.set('token', val);
      }
      else if(key == 'shopid') {
        cookies.set('shopId', val);
        cookies.remove('token');
      }
      else {
        cookies.remove('token');
      }
    }
    else {
      const shopId: any = query['shopid'];
      cookies.set('shopId', shopId);

      if (query['token']) {
        cookies.set('token', query['token']);
      }
      else {
        cookies.remove('token');
      }
    }

    emit('stopLoading');

    await Auth.federatedSignIn({provider: CognitoHostedUIIdentityProvider.Cognito});
  }
  catch(e) {
    console.log(e);
  }

});

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createBlock(PageLoading, { key: 0 }))
    : _createCommentVNode("", true)
}
}

})